import styled, { theme } from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'
import PropTypes from 'prop-types'
import React from 'react'

const HeadingWrapper = styled.div`
  margin-bottom: -13px;
  display: flex;
  justify-content: center;
`
const H2 = styled.h2`
  margin: 0;
  display: inline-block;
  background-color: ${theme('modal.background')};
  font-size: ${rem(18)};
  font-family: ${(p) => p.theme.typography.heading2.fontFamily};
  font-weight: ${(p) => p.theme.typography.heading2.fontWeight};
  color: ${(p) => p.theme.typography.heading2.color};
  padding: 0 20px;
`
const InnerWrapper = styled.div`
  border-radius: ${(p) => p.theme.base.borderRadius || '6px'};
  border: ${rem(1)} solid ${theme('forms.colors.border')};
  padding: ${(p) => p.padding || '21px'};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  font-weight: ${(p) => p.theme.typography.paragraph.fontWeight};
`
const InformationContainer = ({ title, borderRadius, children, padding }) => (
  <div>
    <HeadingWrapper>
      <H2>{title}</H2>
    </HeadingWrapper>
    <InnerWrapper borderRadius={borderRadius} padding={padding}>
      {children}
    </InnerWrapper>
  </div>
)

InformationContainer.defaultProps = {
  title: '',
  borderRadius: '',
}

InformationContainer.propTypes = {
  title: PropTypes.string,
  borderRadius: PropTypes.string,
  padding: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.array,
  ]).isRequired,
}

export default InformationContainer
